<template>
  <div class="box2">
    <pageTitle
      title="谁掌握了数据分析 谁就掌握了未来! "
      text="从IT时代到DT（Data Technology）数据时代，数据浪潮势不可<br/>挡，已经没有【不产生数据、绝对不需要分析数据】的行业。"
      titleColor="#24375C"
      titColor="#86909C"
    />
    <div class="subject-box">
      <div class="nav-box">
        <div
          class="nav"
          :class="{ 'cur-nav': cur == index }"
          v-for="(item, index) in list"
          :key="index"
          @click="changeCur(index)"
        >
          {{ item }}
        </div>
      </div>

      <div class="box" @click="show = true">
        <swiper
          :options="swiperOption"
          ref="mySwiper"
          class="swiperitems"
          @slideChange="slideChange()"
        >
          <swiper-slide class="swiperwrap">
            <div class="wrap">
              <div class="title">
                <img
                  src="../../../assets/coursePage/dataAnalysis/box2/icon.png"
                  alt=""
                />

                人才缺口大
              </div>
              <div class="exp">
                在2022-2023年全球及中国互联网人才需求排行榜中，【数据分析员】跻身TOP5！2023年2月一线及新一线城市的数据分析人才招聘缺口71万+
                ！
              </div>
              <div class="content1">
                <swiper :options="swiperOption2">
                  <swiper-slide>
                    <img
                      src="../../../assets/coursePage/dataAnalysis/box2/1.1.png"
                      alt=""
                    />
                  </swiper-slide>
                  <swiper-slide>
                    <img
                      src="../../../assets/coursePage/dataAnalysis/box2/1.2.png"
                      alt=""
                    />
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiperwrap">
            <div class="wrap">
              <div class="title">
                <img
                  src="../../../assets/coursePage/dataAnalysis/box2/icon.png"
                  alt=""
                />

                行业薪资高
              </div>
              <div class="exp exp2">
                数据显示：全国数据分析师月均可达工资2.4W+，且不少大厂月均可达4W+，买房买车指日可待！
              </div>
              <div class="content1">
                <swiper :options="swiperOption2">
                  <swiper-slide>
                    <img
                      src="../../../assets/coursePage/dataAnalysis/box2/2.1.png"
                      alt=""
                    />
                  </swiper-slide>
                  <swiper-slide>
                    <img
                      src="../../../assets/coursePage/dataAnalysis/box2/2.2.png"
                      alt=""
                    />
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiperwrap">
            <div class="wrap">
              <div class="title">
                <img
                  src="../../../assets/coursePage/dataAnalysis/box2/icon.png"
                  alt=""
                />

                应用范围广
              </div>
              <div class="exp exp2">
                数据时代各行各业都离不开数据，数据分析师正逐渐成为各大企业的核心岗位。
              </div>
              <div class="content1">
                <img
                  src="../../../assets/coursePage/dataAnalysis/box2/3.1.png"
                  alt=""
                />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiperwrap">
            <div class="wrap">
              <div class="title">
                <img
                  src="../../../assets/coursePage/dataAnalysis/box2/icon.png"
                  alt=""
                />

                职业周期长
              </div>
              <div class="exp exp2">
                数据分析受年龄、行业等外部因素相对较小，职位相对稳定，经验导向、越老越“吃香”。
              </div>
              <div class="content1">
                <img
                  src="../../../assets/coursePage/dataAnalysis/box2/4.1.png"
                  alt=""
                />
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination-box2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import box9 from "./Box9.vue";
import scrollBox from "../common/scrollBox.vue";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
    box9,
    scrollBox,
  },
  mounted() {},

  data() {
    let that = this;
    return {
      show: false,
      list: ["人才缺口大", "行业薪资高", "应用范围广", "职业周期长"],
      cur: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box2",
        },
      },
      swiperOption2: {
        loop: true,
        autoplay: true,
        slidesPerView: "auto",
        centeredSlides: true,
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    slideChange() {
      this.cur = this.$refs.mySwiper.$el.swiper.realIndex;
    },
    zixun(name) {
      zhuge.track("H5_Web专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
    changeCur(index) {
      this.swiper.slideTo(index, 0);

      this.cur = index;
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
    zixun(name) {
      zhuge.track("H5_产品经理专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
    slideChange() {
      this.cur = this.$refs.mySwiper.$el.swiper.realIndex;
    },
  },
};
</script>

<style lang="less" scoped>
.box2 {
  padding: 204px 0 88px;

  width: 100%;
  background: url("../../../assets/coursePage/dataAnalysis/box2/bgc.png")
    no-repeat;
  background-size: cover;
  position: relative;
  .nav-box {
    padding: 0 32px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-top: 48px;
    .nav {
      width: 160px;
      height: 72px;
      border-radius: 12px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #969696;
      line-height: 72px;

      text-align: center;
    }

    .cur-nav {
      background: linear-gradient(224deg, #6aaefe 0%, #6a7fee 100%);
      position: relative;
      color: #ffffff;
    }
  }
  .box {
    width: 750px;

    padding-top: 36px;
    box-sizing: border-box;
    margin-top: -4px;
  }
  .subject-box {
    position: relative;
    margin: 0px auto 0;
    // padding-bottom: 22px;
    width: 100%;
    overflow: hidden;
    .swiperwrap {
      width: 686px;

      padding-bottom: 30px;
      border-radius: 16px;
      backdrop-filter: blur(12px);
      .wrap {
        width: 686px;
        height: 930px;
        background: linear-gradient(
          222deg,
          rgba(249, 248, 255, 0.75) 0%,
          #ffffff 27%,
          rgba(255, 255, 255, 0.98) 55%,
          #ffffff 100%
        );
        box-shadow: 6px 10px 18px 0px rgba(199, 227, 240, 0.29);
        border-radius: 16px;
        backdrop-filter: blur(12px);
        padding: 40px 22px 40px 22px;
        box-sizing: border-box;

        overflow: hidden;
        .title {
          font-size: 28px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #1d2129;
          line-height: 52px;
          display: flex;
          align-items: center;
          margin-left: 18px;
          img {
            width: 30px;
            height: 24px;
            margin-right: 14px;
          }
        }
        .exp {
          margin-top: 16px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #727276;
          line-height: 40px;
          margin-bottom: 38px;
          margin-left: 18px;
          margin-right: 18px;
        }
        .exp2 {
          margin-bottom: 38px;
        }
        .content1 {
          height: 616px;

          border-radius: 24px;
          position: relative;
          img {
            width: 642px;
            height: 652px;
          }
        }
      }
    }
  }
  .swiper-pagination-box2 {
    display: flex;
    align-items: center;
    width: max-content;
    height: 6px;
    justify-content: center;
    background: #c2c9fb;
    border-radius: 3px;
    margin: 5px auto 0;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #c2c9fb;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #604bfa;
    border-radius: 3px;
  }
}
</style>
